import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function CitationTabs({
  citationTab,
  handleCitationTabChange,
  citationInputs,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: { xs: 2, md: 3 },
      }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={citationTab}
          onChange={handleCitationTabChange}
          aria-label="citation tabs ">
          <Tab
            value="fullCitation"
            label="Full Citation"
            id="full-citation"
            aria-controls="full-citation"
          />
          <Tab
            value="textCitation"
            label="In-text Citation"
            id="in-text-citation"
            aria-controls="in-text-citation"
          />
        </Tabs>
      </Box>
      <>{citationInputs || ""}</>
    </Box>
  );
}
